import { useMapBridge } from '../bridge'
import { TCoordinates } from '../map-manager'

export const useIOSGeolocation = () => {
  const { mapBridge } = useMapBridge()

  const getUserLocation = async (): Promise<TCoordinates | null> => {
    const position = await mapBridge.getUserLocation()

    return position
  }

  return { getIOSUserLocation: getUserLocation }
}
